import { render } from "./ConversionSalesStoresBrands.vue?vue&type=template&id=917f4000&scoped=true"
import script from "./ConversionSalesStoresBrands.vue?vue&type=script&lang=js"
export * from "./ConversionSalesStoresBrands.vue?vue&type=script&lang=js"

import "./ConversionSalesStoresBrands.vue?vue&type=style&index=0&id=917f4000&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917f4000"]])

export default __exports__